
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.873 9.455c-.11.296-.162.577-.162.842-.017.288.103.437.358.444.657-.015 1.245-.405 1.774-1.177.528-.741.801-1.693.818-2.863-.025-1.411-.545-2.519-1.56-3.314-1.015-.773-2.276-1.17-3.777-1.178-1.722.023-3.095.561-4.127 1.63-1.065 1.045-1.603 2.379-1.62 3.986.009 1.84.58 3.29 1.697 4.336 1.091 1.076 2.498 1.614 4.212 1.63 1.825-.016 3.325-.64 4.493-1.88h1.399c-1.399 2.02-3.385 3.05-5.96 3.089-2.098-.023-3.846-.694-5.244-2.02C1.75 11.67 1.026 9.93 1 7.754c.026-1.942.75-3.548 2.183-4.804C4.573 1.67 6.286 1.023 8.324 1c1.833.016 3.393.515 4.68 1.513 1.305.998 1.97 2.317 1.996 3.962-.017.936-.17 1.747-.477 2.426-.333.686-.742 1.271-1.245 1.74-1.058.927-2.038 1.395-2.95 1.395-.299 0-.572-.086-.793-.257-.222-.187-.35-.46-.375-.803h-.035c-.264.288-.588.53-.98.725-.392.226-.81.335-1.245.335-.827-.015-1.509-.304-2.038-.881-.57-.546-.852-1.232-.852-2.06 0-1.247.4-2.362 1.21-3.337.776-.975 1.817-1.482 3.13-1.506.963-.015 1.696.437 2.216 1.35l.358-1.069h1.382l-1.433 4.922zm-3.598 1.177c.401 0 .776-.117 1.117-.358.333-.211.614-.484.853-.82.494-.71.742-1.427.759-2.152-.009-.46-.162-.85-.46-1.162-.29-.312-.666-.468-1.118-.484-.392 0-.759.102-1.1.304a3.15 3.15 0 00-.87.804c-.51.678-.767 1.404-.767 2.16 0 .5.145.905.435 1.217.299.328.682.491 1.151.491z","fill":"#8F7A61"}})])
          )
        }
      }
    